import { InjectionToken } from '@angular/core';
import { SupabaseKey, SupabaseUrl } from '@sankarah/shared-environment';
import { SupabaseClient } from '@supabase/supabase-js';

export interface CommoSharedDataAccessConfig {
  supabaseUrl: SupabaseUrl;
  supabaseKey: SupabaseKey;
}

export const COMMO_SHARED_DATA_ACCESS_CONFIG =
  new InjectionToken<CommoSharedDataAccessConfig>(
    '@sankarah/commo-shared-data-access Configuration',
  );

export const COMMO_SHARED_SUPABASE_CLIENT = new InjectionToken<SupabaseClient>(
  'COMMO_SHARED_SUPABASE_CLIENT',
);
